module.exports = __webpack_public_path__ + "img/flight-ID-batik-circle.2b8f8213.svg";